import { useMemo } from "react";

export function useNumberOfSlotsFromRespondents(respondents) {
  return useMemo(
    () => respondents.filter(({ isChecked }) => isChecked).length,
    [respondents]
  );
}

export function getNumberOfPeopleFromRespondents(respondents) {
  return respondents.filter((r) => r.isChecked).length;
}

export function getCurrentlySignedUpCount(state, signupItemID) {
  try {
    return state?.userSignupItems[signupItemID].count;
  } catch (e) {
    return 0;
  }
}
